import { Path, Svg, SVGProps } from "@react-pdf/renderer";

export const MoneyIcon = (props: SVGProps) => (
  <Svg {...props} viewBox="0 0 28 28">
    <Path
      d="M17.0168 11.5146C17.0168 10.1429 15.9363 9.03091 14.6034 9.03091H13.3968C12.0639 9.03091 10.9834 10.1429 10.9834 11.5146C10.9834 12.8863 12.0639 13.9983 13.3968 13.9983H14.6034C15.9363 13.9983 17.0168 15.1103 17.0168 16.482C17.0168 17.8537 15.9363 18.9656 14.6034 18.9656H13.3968C12.0639 18.9656 10.9834 17.8537 10.9834 16.482M14.0001 7.78906L14.0001 20.2075"
      fill="none"
      strokeWidth="1.65579"
      strokeLinecap="round"
    />
  </Svg>
);
